var map = {
	"./btc.png": 31577,
	"./chainlink.svg": 93462,
	"./coinbase.svg": 11490,
	"./eth.png": 45855,
	"./glow.svg": 32978,
	"./link.png": 98216,
	"./logo.svg": 79041,
	"./phantom.svg": 67283,
	"./placeholder.png": 50464,
	"./slope.svg": 43420,
	"./sol-faucet.png": 90827,
	"./sol.png": 88993,
	"./solfare.svg": 67563,
	"./spl-token-faucet.png": 59585,
	"./torus.svg": 81825,
	"./usdc.png": 56149,
	"./usdt.png": 35657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53709;